import {createEntityService} from 'utils/createEntityService';
import {PlaceOfService} from '../types/placeOfService';

export const PlaceOfServiceService = createEntityService<PlaceOfService>({
  baseUrl: 'api/v1/place_of_services',
  entityName: 'placeOfService',
});
